export default class ErrorHandler {
  static write(err, vm, info) {
    let handler, current = vm
    console.log('ErrorHandler | ', info, err, vm)

    if (vm.$options.errorHandler) {
      handler = vm.$options.errorHandler
    } else {
      while (current.$parent) {
        current = current.$parent
        if (handler = current.$options.errorHandler)
          break
      }
    }

    /*if(typeof err == "object"){
      console.log(info, err.stack.toString(), vm)
    }else{

    }*/

    if (handler) {
      handler.call(current, err, vm, info)
    } else {
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/ErrorHandler.js